export enum EStorageBucket {
  default = 'default',
}
